// Recat Component
import { createSlice } from "@reduxjs/toolkit"

const userSlice = createSlice({
    name: "user",
    initialState: "",
    reducers: {},
})

export default userSlice.reducer